import React,{useEffect,useState,useContext,createRef} from 'react';
import ReactTooltip from 'react-tooltip';
import {  Container, Row, Col, Modal, Button, Nav, Form, InputGroup } from 'react-bootstrap';
// ListGroup,, ToggleButton
import { Link } from "react-router-dom";

import sanitize from 'sanitize-filename';

import bsCustomFileInput from 'bs-custom-file-input';

import { org_uuid, org_friendly_url, apiUrl, myHeaders_Auth_With_Cache_Control, myHeaders_Authorized } from "Api/Api";

import axios from "axios";

import { local_routes } from 'utils/Routes';

import Select from 'react-select';

import UserContext from 'store/UserContext';

//import { slugify } from 'utils/Helper';

//import { useForm } from 'react-hubspot'

// import { assembleNickname, get_current_unix_stamp } from "utils/Helper.js";

//import { makeCall } from "components/VideoChat/VideoChatControl";

import './style.css';

function ManageGroupModal (props) {
  //console.log("OnboardingModal constructor",props);
  
  const user_context = useContext(UserContext);
  
  const group_form_ref = createRef();
  
  const [validated, setValidated] = useState(false);
  
  const [tab_choice, setTabChoice] = useState('description'); // or events or users

  const [event_options, setEventOptions] = useState([]);
  
  const [selected_event_option, setSelectedEventOption] = useState(null);

  //const [step_name, setStepName] = useState('');
  const [loading, setLoading] = useState(false);
  
  const [group_info, setGroupInfo] = useState({});
  
  const [props_group_info, setPropsGroupInfo] = useState(props.group_info);
  
  //const [org_event_array, setOrgEventArray] = useState([]);
  const [group_event_array, setGroupEventArray] = useState([]);
  
  const [group_image, setGroupImage] = useState(null);
  
  //const [followed_entities, setFollowedEntities] = useState([]);
  
  const [message, setMessage] = useState(<React.Fragment></React.Fragment>);
  
  let workspace_base_url = "";
  if (org_friendly_url) {
    workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
  }
  

  const tab_info = {
    description: {
      title: "Description",
    },
    events: {
      title: "Events"
    }
  };

  /*
  async function onUnFollow (selected_entity) {
    console.log("onUnFollow",selected_entity);
    
    // first remove from state
    let tmp_followed_entities = followed_entities.filter( element => element.entity_uuid !== selected_entity.entity_uuid );
    setFollowedEntities(tmp_followed_entities);
    
    let patch_obj = {
      [tab_choice+'.audience']: [
        {
          entity_uuid: selected_entity.entity_uuid,
          xref_data: {
            favorited_time: -1
          }
        }
      ]
    };
    
    await axios.patch(`${apiUrl}users/${user_context.user_info.entity_uuid}`,patch_obj);
    
  }
  */

  async function setupEntities (tmp_tab_choice = tab_choice, tmp_group_info = props_group_info) {
    console.log("ManageGroupModal setupEntities", tmp_group_info);
    setMessage(<span style={{ color: 'darkgray', fontSize: 'smaller' }}> Working...</span>);

    //setGroupInfo(props.group_info);
    
    if (tmp_tab_choice === 'description') {
      let group_info_response = await axios.get(`${apiUrl}groups/${tmp_group_info.entity_uuid}`,myHeaders_Auth_With_Cache_Control);

      if (group_info_response.data.image_url) {
        group_info_response.data.image_url_short = group_info_response.data.image_url.split('/').pop();
      }

      setGroupInfo(group_info_response.data);
      //setGroupInfo[props.group_info];
    } else if (tmp_tab_choice === 'events') {
      console.log("Getting events");
      let api_promises = [];
      api_promises.push(axios.get(`${apiUrl}organizations/${org_friendly_url}/events`,myHeaders_Auth_With_Cache_Control));
      api_promises.push(axios.get(`${apiUrl}groups/${tmp_group_info.entity_uuid}/events`,myHeaders_Auth_With_Cache_Control));
      
      let [organization_events_response, group_events_response] = await Promise.all(api_promises);
      
      //setOrgEventArray(organization_events_response.data);
      let tmp_event_options = organization_events_response.data.map( element => {
        let tmp_option = {
          value: element,
          label: element.entity_name
        }
        return tmp_option;
      }).sort((a, b) => a.label.localeCompare(b.label));
      //console.log("tmp_event_options",tmp_event_options);
      
      group_events_response.data.forEach( element => {
        tmp_event_options = tmp_event_options.filter( element2 => element2.value.entity_uuid !== element.entity_uuid);
      });
      
      let tmp_org_events = group_events_response.data
      
      setEventOptions(tmp_event_options);
      
      setGroupEventArray(group_events_response.data.sort((a, b) => a.entity_name.localeCompare(b.entity_name)));
    }

    setMessage(<span>&nbsp;</span>);
    setLoading(false);
  }

  async function changeTab (eventKey) {
    console.log("changeTab",eventKey,tab_choice);
    if (eventKey !== tab_choice) {
      //setFollowedEntities([]);
      //setMessage(<span>&nbsp;</span>);
      setTabChoice(eventKey);
      await setupEntities(eventKey);
      //setMessage(<span>&nbsp;</span>);
    }
    
  }

  // on mount
  useEffect(() => {
    console.log("ManageGroupModal useEffect props.show");
    
    bsCustomFileInput.init();

    if (!user_context.user_info || !user_context.user_info.entity_uuid) {
      return;
    }
    
    if (props_group_info.entity_uuid) {
      setupEntities();
    }
    
  }, [props.show]);
  
  function onChangeFile (event) {
    console.log("onChangeFile",event.target.files);
    if (event.target.files[0]) {
      setGroupImage(event.target.files[0]);
    }
    setMessage(<span>&nbsp;</span>);
  }
  
  async function onSave () {
    // first do the image
    console.log("onSave");
    
    if (group_form_ref.current.checkValidity() === false) {
      console.log("INVALID");
      setValidated(true);
      return;
    }
    
    setMessage(<span style={{ color: 'darkgray', fontSize: 'smaller' }}> Working...</span>);
    
    let group_uuid = "";

    let friendly_url = ""; // so we can bust cache
    
    if (!props_group_info.entity_uuid) {
      // CREATE
      let post_obj = {
        entity_name: group_info.entity_name,
        description: group_info['description'],
        friendly_url: group_info.entity_name,
        public_status: 'private'
      };

      let post_response = await axios.post(`${apiUrl}groups`,post_obj,myHeaders_Authorized);
      if (post_response.data.friendly_url) {
        friendly_url = post_response.data.friendly_url;
      }
      group_uuid = post_response.data.entity_uuid;
    } else {
      // EDIT
      let patch_obj = {
        entity_name: group_info.entity_name,
        description: group_info['description']
      }

      group_uuid = props_group_info.entity_uuid;
      friendly_url = props_group_info.friendly_url;
      let patch_response = await axios.patch(`${apiUrl}groups/${group_uuid}`,patch_obj,myHeaders_Authorized);
      if (patch_response.data.friendly_url) {
        friendly_url = patch_response.data.friendly_url;
      }
    }
    
    // now do the image if needed
    if (group_image) {
      let image_data_promise = new Promise(resolve => {
        let reader = new FileReader();
        reader.readAsArrayBuffer(group_image);
        reader.onload = () => resolve(reader.result);
      });
      let group_image_name = sanitize(group_image.name);
      let image_upload_data = await axios.post(`${apiUrl}groups/${group_uuid}/getUploadSignedUrl?asset_type=image&filename=${group_image_name}`, {}, myHeaders_Authorized);
      const config = { headers: { "Content-Type": image_upload_data.data.content_type } };
      let uploadUrl = image_upload_data.data.upload_url;
      let image_data = await image_data_promise;
      await axios.put(uploadUrl, image_data, config);
    }
    
    // bust cache
    if (!props_group_info.entity_uuid) {
      // create - get newly created group data from API, bust cache, and move user to events tab
      let [tmp_group_info,dummy] = await Promise.all([
        axios.get(`${apiUrl}groups/${friendly_url}`,myHeaders_Auth_With_Cache_Control),
        axios.get(`${apiUrl}organizations/${org_friendly_url}/groups`,myHeaders_Auth_With_Cache_Control)
      ]);
      
      setPropsGroupInfo(tmp_group_info.data);
      setTabChoice('events');
      setupEntities('events',tmp_group_info.data);
      
      
      //if (org_friendly_url) {
        //await axios.get(`${apiUrl}organizations/${org_friendly_url}/groups`,myHeaders_Auth_With_Cache_Control);
      //} else {
        //await axios.get(`${apiUrl}groups`,myHeaders_Auth_With_Cache_Control);
      //}
    } else {
      // edit
      await axios.get(`${apiUrl}groups/${friendly_url}`,myHeaders_Auth_With_Cache_Control);
      props.onHide();
    }
    

    /*
    let patch_obj = {
      entity_name: group_info.entity_name,
      description: group_info['description']
    }
    await axios.patch(`${apiUrl}groups/${props.group_info.entity_uuid}`,patch_obj,myHeaders_Authorized);
    */
    setMessage(<span style={{ color: 'green', fontSize: 'smaller' }}> Changes Saved</span>);
    
    if (props.onSaveCallback) {
      props.onSaveCallback();
    }
  }
  
//   function myPublishChangeHandler (event) {
//     console.log("myPublishChangeHandler");
//     let tmp_group_info = {...group_info};
//     if (tmp_group_info.status_code === 1) {
//       tmp_group_info.status_code = 4;
//     } else {
//       tmp_group_info.status_code = 1;
//     }
//     setGroupInfo(tmp_group_info);
//     setMessage(<span>&nbsp;</span>);
//   }
  
  function myChangeHandler (event) {
    console.log("myChangeHandler",event.target.id,event.target.checked);
    let tmp_group_info = {...group_info};

    if (event.target.id === 'status_code') {
      if (event.target.checked) {
        //event.target.value = parseInt(1);
        tmp_group_info.status_code = 1;
      } else {
        //event.target.value = parseInt(4);
        tmp_group_info.status_code = 4;
      }
    } else {
      tmp_group_info[event.target.id] = event.target.value;
    }
    //console.log("YO",tmp_group_info);
    setGroupInfo(tmp_group_info);
    setMessage(<span>&nbsp;</span>);
  }

  function onDropdownEventChange (selectedEvent) {
    if (!selectedEvent) {
      return;
    }
    console.log("onDropdownEventChange",selectedEvent);
    setSelectedEventOption(selectedEvent);
  }
  
  async function addEvent () {
    console.log("addEvent",selected_event_option);

    let tmp_event_array = [...group_event_array];
    tmp_event_array.push(selected_event_option.value);
    tmp_event_array = tmp_event_array.sort((a, b) => a.entity_name.localeCompare(b.entity_name));
    
    let tmp_event_options = [...event_options];
    
    tmp_event_options = tmp_event_options.filter( element => element.value.entity_uuid !== selected_event_option.value.entity_uuid);

    setSelectedEventOption(null);
    setGroupEventArray(tmp_event_array);
    setEventOptions(tmp_event_options);
    
    await axios.post(`${apiUrl}groups/${props_group_info.entity_uuid}/events/${selected_event_option.value.entity_uuid}`,{});
    
    // bust cache
    await axios.get(`${apiUrl}groups/${props_group_info.friendly_url}/events`,myHeaders_Auth_With_Cache_Control);
    
    if (props.onSaveCallback) {
      props.onSaveCallback();
    }
  }
  
  async function removeEvent (event_info) {
    console.log("removeEvent",event_info);

    let tmp_event_options = [...event_options];
    tmp_event_options.push({
      label: event_info.entity_name,
      value: event_info
    });
    tmp_event_options = tmp_event_options.sort((a, b) => a.label.localeCompare(b.label));
    
    let tmp_event_array = [...group_event_array];
    
    tmp_event_array = tmp_event_array.filter( element => element.entity_uuid !== event_info.entity_uuid);

    setSelectedEventOption(null);
    setGroupEventArray(tmp_event_array);
    setEventOptions(tmp_event_options);

    await axios.delete(`${apiUrl}groups/${props_group_info.entity_uuid}/events/${event_info.entity_uuid}`);
    
    // bust cache
    await axios.get(`${apiUrl}groups/${props_group_info.friendly_url}/events`,myHeaders_Auth_With_Cache_Control);
    
    if (props.onSaveCallback) {
      props.onSaveCallback();
    }
  }

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      //{...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      scrollable={true}
      style={{ color: 'black' }}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {props_group_info.entity_uuid ? `Manage Group ${props_group_info.entity_name}` : 'Add New Group'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container style={{ height: "400px" }}>
          {props_group_info.entity_uuid &&
            <Row style={{ paddingBottom: "10px" }}>
              <Col>
                <Nav justify variant="tabs" activeKey={tab_choice} onSelect={(k) => changeTab(k)}>
                  {
                    Object.keys(tab_info).map( tab_name => {
                      return (
                        <Nav.Item key={tab_name}>
                          <Nav.Link eventKey={tab_name}>{tab_info[tab_name].title}</Nav.Link>
                        </Nav.Item>
                      );
                    })
                  }
                </Nav>
              </Col>
            </Row>
          }
          {tab_choice === 'description' &&
            <Row>
              <Col>
                <Form
                  ref={group_form_ref}
                  noValidate
                  validated={validated}
                >
                  {/*
                  <ToggleButton
                    //id="status_code"
                    type="checkbox"
                    variant="pkprimary"
                    checked={group_info.status_code === 1 ? true : false}
                    //value="1"
                    onChange={myPublishChangeHandler}
                  >
                    {group_info.status_code === 1 ? 'Click to Unpublish' : 'Click to Publish'}
                  </ToggleButton>
                  */}
                  {/*
                  <Form.Check
                    custom={true}
                    type="checkbox"
                    variant="pkprimary"
                    id="status_code"
                    label={`Published?`}
                    onChange={myChangeHandler}
                    checked={group_info.status_code === 1 ? true : false}
                    //value={group_info.status_code === 1 ? }
                  />
                  */}
                  <Form.Group controlId="entity_name">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      placeholder="Enter Group Name"
                      value={group_info.entity_name || ''}
                      onChange={myChangeHandler}
                      pattern=".{3,}"
                      maxLength={120}
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                        Please enter a name between 3 and 120 characters long
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group controlId="description">
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows="3"
                      placeholder="Enter Group Description"
                      value={group_info['description'] || ''}
                      onChange={myChangeHandler}
                      required
                      pattern=".{3,4000}"
                      maxLength="4000"
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter a description between 3 and 4000 characters long
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group>
                  <Form.Label>Image (16:9 aspect ratio recommended)</Form.Label>
                  <Form.File 
                    id="custom-file"
                    custom={true}
                  >
                    <Form.File.Label>{group_info.image_url_short || 'Click to Upload Image File'}</Form.File.Label>
                    <Form.File.Input
                      onChange={onChangeFile}
                    />
                  </Form.File>
                  </Form.Group>
                </Form>
              </Col>
            </Row>
          }
          {tab_choice === 'events' &&
            <React.Fragment>
            <Row style={{ marginTop: "5px" }}>
              <Col>
                <Form.Label>
                  Add Existing Published Event to Group
                </Form.Label>
                <InputGroup style={{ marginBottom: "7px" }}>
                  <div style={{ marginRight: "2px", width: '70%' }}>
                  <Select
                    //styles={{ width: "80%" }}
                    //styles={{ menuPortal: base => ({ ...base, fontSize: "smaller", zIndex: 9999 }) }}
                    //menuPortalTarget={document.querySelector('body')}
                    //className='workspace_dropdown_menu'
                    //classNamePrefix=''
                    placeholder="Available Events..."
                    value={selected_event_option}
                    onChange={onDropdownEventChange}
                    options={event_options}
                  />
                  </div>
                  <Button
                    variant="pkprimary"
                    onClick={addEvent}
                    disabled={!selected_event_option}
                  >
                    Add to Group
                  </Button>
                </InputGroup>
                <Form.Label>
                  Want to create a new group event? First <Link
                    to={{
                        pathname: `${workspace_base_url}${local_routes.manageevent}`,
                        data: {
                            source: {
                                entity_type: 'organizations',
                                entity_uuid: org_uuid,
                                referrer: `${workspace_base_url}${local_routes.groups}/${props_group_info.friendly_url}`
                            }
                        }
                    }}
                  >create your event</Link>, and then come back here to add it to your group.
                </Form.Label>
              </Col>
            </Row>
            <hr/>
            
              { group_event_array.map( element => {
                return (
                  <Row key={element.entity_uuid} style={{ marginTop: "10px" }} className="justify-content-between">
                    <Col xs={6}>
                      {element.entity_name}
                    </Col>
                    <Col xs="auto">
                      <Button
                        variant="pkprimary"
                        onClick={() => removeEvent(element)}
                      >
                        Remove from Group
                      </Button>
                    </Col>
                  </Row>
                );
              })}
            </React.Fragment>
          }
          <Row>
            <Col>
              {message}
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        {tab_choice === 'description' &&
          <Button variant="pkprimary" onClick={onSave}>{props_group_info.entity_uuid ? 'Save' : 'Create'}</Button>
        }
        {/* <Button variant="secondary" onClick={props.onHide}>Done</Button> */}
      </Modal.Footer>
    </Modal>
  );
}

function ManageGroupModalButton (props) {
  const [modalShow, setModalShow] = React.useState(false);

  console.log("ManageGroupModalButton",props);

  let button_icon = '';
  let button_text = props.group_info.entity_uuid ? 'Manage Group' : 'Create Group';
  //if (props.event_entity_name) {
  //  button_text = props.event_entity_name;
  //}
  let button_tooltip = 'Click to see more options';

  return (
    <React.Fragment>
      <Button variant="pkprimary" onClick={() => setModalShow(true)}>
        {button_icon}{button_text}
      </Button>

      <ManageGroupModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        group_info={props.group_info}
        onSaveCallback={props.onSaveCallback || null}
      />
      <ReactTooltip />
    </React.Fragment>
  );
}

export default ManageGroupModalButton;